module.exports = __webpack_public_path__ + "img/KLUE_logo.b60aad34.svg";